import { Button, Radio } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import CreateProfileCardWrapper from "../../components/common/CreateProfileCardWrapper";
import { setInfoContent } from "../../redux/slices/common_slice";
import "./OnboardingPage.css";

const ImmigrationStatusPage = ({ formik }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  return (
    <CreateProfileCardWrapper>
      <h5 className="d-flex align-items-center justify-content-between">
        {formik.values?.livingInCanada === "yes"
          ? t("aboutYou.ques7.title")
          : "What will your immigration status be when you arrive?"}
        <Button
          className="border-0 bg-tranaparent w-auto h-auto shadow-none p-0 info-icon-btn"
          onClick={() => {
            dispatch(setInfoContent(t("aboutYou.resources.3")));
          }}
        >
          <img
            src="/assets/images/icons/info-circle-icon.svg"
            alt=""
            className="img-fluid"
          />
        </Button>
      </h5>
      <div className="status-options">
        <Radio.Group
          className="w-100"
          name="selectedStatus"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.selectedStatus}
        >
          <div className="list-item">
            <Radio value="student">{t("aboutYou.ques7.options.1")}</Radio>
          </div>
          <div className="list-item">
            <Radio value="temporaryResident">
              {t("aboutYou.ques7.options.2")}
            </Radio>
          </div>
          <div className="list-item">
            <Radio value="permanentResident">
              {t("aboutYou.ques7.options.3")}
            </Radio>
          </div>
          <div className="list-item">
            <Radio value="canadianCitizen">
              {t("aboutYou.ques7.options.4")}
            </Radio>
          </div>
          <div className="list-item">
            <Radio value="refugee">{t("aboutYou.ques7.options.5")}</Radio>
          </div>
          <div className="list-item">
            <Radio value="visitor">{t("aboutYou.ques7.options.6")}</Radio>
          </div>
          <div className="list-item">
            <Radio value="preferNotToSay">
              {formik.values?.livingInCanada === "yes"
                ? t("aboutYou.ques7.options.7")
                : "Unsure/Prefer not to say"}
            </Radio>
          </div>
        </Radio.Group>
      </div>
      {formik.touched.selectedStatus && formik.errors.selectedStatus ? (
        <div className="error-message">{formik.errors.selectedStatus}</div>
      ) : null}
    </CreateProfileCardWrapper>
  );
};

export default ImmigrationStatusPage;
